<template>
    <ul>
        <li v-for="(value, key) in json" :key="key">
            <template v-if="isObject(value)">
                <strong>{{ key }}</strong> <JsonTree :json="value" :parent-key="key" />
            </template>
            <template v-else-if="isArray(value)">
                 <strong>{{ key }}</strong>:
                 <template v-if="isObject(value) || isArray(value)">
                     <JsonTree :json="value" :parent-key="key" />
                 </template>
            </template>
            <template v-else>
                <strong>{{key}}:</strong> {{value}}
            </template>
        </li>
    </ul>
</template>

<script>

export default {
    name: "JsonTree",
    methods: {
        isObject(val) {
            return val && typeof val === 'object' && !Array.isArray(val);
        },
        isArray(val) {
            return val && Array.isArray(val);
        }
    },
    props: ["json", "parentKey"],
}
</script>
